import React from 'react';
// import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";
import {
	// Breadcrumb,
	// Card,
	Row,
	Col,
	// Input,
	// Button,
	// Table,
	// Modal,
	message,
	// Alert,
	// Select,
	// Tooltip,
	// Spin,
	// Form,
	// Skeleton
} from 'antd';

// import moment from 'moment';

import Config from '../../Config';
import { Helmet } from "react-helmet";
import queryString from 'query-string';

import '../../assets/laporan.css';


const configClass = {
	title: 'LAPORAN OPSEN KABUPATEN / KOTA',
	apiUrl: {
		preview: 'laporan/api/sts_harian/',
		userProfile: "auth/api/user/info"
	},

}

class StsOpsenHarianCetak extends React.Component {
	config;

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			err: false,

			namauptppd: 'SAMSAT PALANGKARAYA',

			tgl_dari: ""
		}

		// this.preview(this.props.match.params.id);

	}

	componentDidMount() {
		var uri_params = "";
		const uri_string = queryString.parse(this.props.location.search);
		
		for (var key in uri_string) {
			if (uri_params == "") {
				uri_params = "?" + key + "=" + uri_string[key];
			} else {
				uri_params += "&" + key + "=" + uri_string[key];
			}
			if(key == "mulai_dari"){
				this.setState({
					tgl_dari: uri_string[key]
				})
			}
		}
		this.preview(uri_params);
	}

	async preview(uri_params) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({
			loading: true,
			err: false,
			data: null,
		});

		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + uri_params)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({
						loading: false,
						data: data,
						err: false
					});
					setTimeout(function () {
						window.print();

					}, 1300);
				} else {
					const errTitle = 'error get laporan';
					this.setState({
						loading: false,
						data: null,
						err: true,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				this.setState({
					loading: false,
					data: null,
					err: true,
					errMsg: 'unknown response'
				});
				console.log('gagal_get_laporan', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		return (
			<>
				<Helmet>
					<title>{configClass.title}</title>
				</Helmet>
				{(this.state.data != null && this.state.data.map((item, idx) => (
					<div className="kertas-laporan-a4">
						<div className="judul-laporan-sts" style={{ borderBottom: "double 5px #000000" }}>
							<img src={this.config.get_site_info().logo_bw} />
							PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
							SURAT TANDA SETORAN (STS) OPSEN PAJAK
						</div>
						<br />
						{
							<table className="laporan-table" cellPadding="5" style={{ border: "1px solid #000000" }}>
							
							{item.opsen.map((subItem, subIdx) => (
							<>
									<tr style={{ border: "1px solid #000000", fontWeight: 'bold' }}>
										
											<td width={300}>
												{subItem.kabupaten}
											</td>
											<td className="teks-kanan">
												|  {(subItem.no_rekening)}--({(subItem.nama_penerima)})  |
											</td>
										
										
									</tr>

									<tr>
										<td style={{ border: "1px solid #000000" }}>- OPSEN PKB </td>
										<td className="teks-kanan" style={{ border: "1px solid #000000" }}>{(subItem.pokok.pkb+subItem.denda.pkb).toLocaleString("id")}</td>
									</tr>
									{(subItem.pokok.bbnkb > 0 &&
									<tr>
										<td style={{ border: "1px solid #000000" }}>- OPSEN BBNKB </td>
										<td className="teks-kanan" style={{ border: "1px solid #000000" }}>{(subItem.pokok.bbnkb+subItem.denda.bbnkb).toLocaleString("id")}</td>
									</tr>
									)}
							</>
							))}
							<tr>
								<td className="teks-kanan" style={{ borderTop: "1px solid #000000", borderRight: "1px solid #000000", borderLeft: "1px solid #000000", fontWeight: 'bold' }}>
									JUMLAH
								</td>
								<td className="teks-kanan" style={{ borderTop: "1px solid #000000", borderRight: "1px solid #000000", borderLeft: "1px solid #000000", fontWeight: 'bold' }}>
									{(item.total_opsen.toLocaleString("id"))}
								</td>
							</tr>
							</table>
						}
						<br />
						{(item.ttd != undefined &&
							<Row justify="space-between" style={{ marginTop: 10, fontSize:12 }}>
								<Col span={16} className='text-tengah'></Col>
								<Col span={8} className='text-tengah'>
									{item.kabupaten_asal}, TGL {this.state.tgl_dari}
								</Col>
								<Col span={8} className="teks-tengah">
									{item.ttd.ttd.kiri.jabatan}<br />
									<div style={{ marginTop: 50 }}>
										<b>
											<u>{item.ttd.ttd.kiri.nama}</u>
										</b>
										<br />
										NIP : {item.ttd.ttd.kiri.nip}
									</div>
								</Col>
								<Col span={8} className="teks-tengah">
									{item.ttd.ttd.kanan.jabatan}<br />
									<div style={{ marginTop: 50 }}>
										<b>
											<u>{item.ttd.ttd.kanan.nama}</u>
										</b>
										<br />
										NIP : {item.ttd.ttd.kanan.nip}
									</div>
								</Col>
								<Col span={8} className="teks-tengah">
								</Col>

							</Row>
						)}
					</div>
				)))}
			</>
		)
	}

}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(StsOpsenHarianCetak);